module.exports = __webpack_public_path__ + "assets/img/new_main_icon.738a7178.png";